var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      class: [
        "main-header",
        _vm.image === null ? "without-image" : "",
        _vm.image
      ]
    },
    [
      _vm.back && _vm.back.label
        ? _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: _vm.back.href,
                  params: _vm.back.params,
                  query: _vm.back.query
                }
              }
            },
            [
              _c("Icon", { attrs: { name: "arrow_back" } }),
              _c("span", { staticClass: "onglet" }, [
                _vm._v(_vm._s(_vm.back.label))
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.title
        ? _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))])
        : _vm._e(),
      _vm._v(" "),
      _vm.navigation && _vm.navigation.length > 0
        ? _c("Navigation", { attrs: { actions: _vm.navigation } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4222160", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4222160","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Header.vue
// module id = 7c+b
// module chunks = 15